import firebase from 'firebase/app'
import 'firebase/auth'

import env from '../constants/env'

if (!firebase.apps.length) {
  firebase.initializeApp(env.firebase)
}

window.auth = firebase.auth()

export default firebase



// WEBPACK FOOTER //
// ./src/firebase/firebase.js